<nav class="planning-top-nav" [class.hidden]="isHidden" aria-label="Planning navigation">
  <div class="nav-shell">
    <div class="nav-scroll">
      <ul class="nav-segment" role="tablist">
        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/planning/work-orders"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Work Orders
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/planning/projects"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Projects
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/planning/yyww"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            YYWW
          </a>
        </li>

        <li role="presentation">
          <a
            #navLink
            routerLink="/settings/planning/weekly-calendar"
            routerLinkActive="active"
            [routerLinkActiveOptions]="{ exact: true }"
            role="tab"
          >
            Weekly Calendar
          </a>
        </li>
      </ul>
    </div>
  </div>
</nav>